module.exports = __webpack_public_path__ + "media/images/arrow_down-1aed563024a720a0231865ed732c4823.svg";